// extracted by mini-css-extract-plugin
export default {"container":"information_container__cuL+p","info__inner":"information_info__inner__p+Sjc","info__title":"information_info__title__6oyfr"};